export class IntraArticularAdditionalInfoA {
  static left_Fore = "LF";
  static right_fore = "RF";
  static left_hind = "LH";
  static right_hind = "RH";
}

export class IntraArticularAdditionalInfoB {
  static fetlock = "fetlock";
  static carpus = "carpus";
  static hock = "hock";
  static stifle = "stifle";
  static other = "other";
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/core/types/intra-articular-info-types.ts